import React from "react";

const PageHeader = ({ title, selectedBrand, children, subtitle }) => {
  return (
    <div className="mb-4 sm:mb-6">
      <h1 className="text-foreground mb-1 text-2xl font-semibold break-words sm:text-3xl">
        {title} {selectedBrand?.name ? `- ${selectedBrand.name}` : ""}
      </h1>
      {subtitle && (
        <p className="text-muted-foreground mb-1 text-sm sm:text-base">
          {subtitle}
        </p>
      )}
      {children}
    </div>
  );
};

export default PageHeader;
